module.exports = __webpack_public_path__ + "static/media/landingPageVideo1FR.79d84f90.png";